import { ActionDimensions } from "../dimensions/ActionDimensions";
import Cookies from 'js-cookie';
import { defaultOptions, setCookie } from "./commonCookiesFunctions";
const updateScreenHistory = (screenName) => {
    var _a;
    const prevScreenParsed = (_a = Cookies.get('prevScreen')) !== null && _a !== void 0 ? _a : '';
    const prevScreenArr = prevScreenParsed.split(',');
    let prevScreen = '';
    if (prevScreenArr.length === 1)
        prevScreen = prevScreenArr[0];
    else
        prevScreen = prevScreenArr[1];
    if (prevScreen)
        ActionDimensions.getInstance().prevScreen = prevScreen;
    ActionDimensions.getInstance().currScreen = screenName;
    setCookie('prevScreen', screenName, Object.assign(Object.assign({}, defaultOptions), { expires: 10 }));
};
export { updateScreenHistory };
